var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDolarSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 38.213C23.125 41.653 25.765 44.4263 29.045 44.4263H35.7383C38.5917 44.4263 40.9117 41.9997 40.9117 39.013C40.9117 35.7597 39.4983 34.613 37.3917 33.8663L26.645 30.133C24.5383 29.3863 23.125 28.2397 23.125 24.9863C23.125 21.9997 25.445 19.573 28.2983 19.573H34.9917C38.2717 19.573 40.9117 22.3463 40.9117 25.7863",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16V48",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 58.6666H24C10.6667 58.6666 5.33337 53.3333 5.33337 39.9999V23.9999C5.33337 10.6666 10.6667 5.33325 24 5.33325H40C53.3334 5.33325 58.6667 10.6666 58.6667 23.9999V39.9999C58.6667 53.3333 53.3334 58.6666 40 58.6666Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolarSquare);
export default __webpack_public_path__ + "static/media/dolar-square.de3a5873c470794f5a1063d6bdf2ac31.svg";
export { ForwardRef as ReactComponent };